import { TranslocoModule } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthNavComponent } from '../auth-nav/auth-nav.component';
import { ModalService } from '../../../shared/utils/services/modal.service';
import { ModalComponent } from '../../../shared/ui/modal/modal.component';

@Component({
  selector: 'qwiko-auth-shell',
  imports: [RouterModule, AuthNavComponent, ModalComponent, TranslocoModule],
  templateUrl: './auth-shell.component.html',
  styleUrl: './auth-shell.component.scss',
})
export class AuthShellComponent {
  private modalService = inject(ModalService);
  closeModal(modal: string) {
    this.modalService.close(modal);
  }
}
